module.exports = __webpack_public_path__ + "img/advanced-chemistry.09f5d87b.png";